<script>
import { mapGetters, mapActions } from 'vuex'

import { urlApi, apiSecond } from '@/boot/axios'

import { loadFile } from '@/helpers/index'

import AccontQuota from './AccontQuota.vue'
import ProjectPowerUser from '@/views/account/power-reservoir/components/ProjectPowerUser.vue'
import MainFilters from '@/components/MainFilters.vue'
import PermissionsFishingPlans from '@/components/PermissionsFishingPlans.vue'
import SubjectProfileCard from '@/components/SubjectProfileCard.vue'
import AqTabs from '@/components/aqua/AqTabs.vue'
import { tabFromQuery, syncTabQuery } from '@/helpers/profileTabs'

export default {
	name: 'AccountInfoIndex',
	components: { AccontQuota, ProjectPowerUser, MainFilters, PermissionsFishingPlans, SubjectProfileCard, AqTabs },
	data() {
		return {
			applicationsUser: null,
			//applicationPermission: null,
			applicationReference: null,
			applicationsPond: null,
			applicationsRegion: null,
			applicationsFish: null,
			astanaIntegrateUpdate: false,
			astanaIntegrateData: null,
			astanaIntegrateList: null,

			applicationsTrade: null,
			tradeIntegrateUpdate: true,
			tradeMessage: {
				status: null,
				text: null,
			},

			applicationsGrownTrade: null,
			grownTradeUpdatee: true,
			grownTradeMessage: {
				status: null,
				text: null,
			},

			applicationsPurchasedTrade: null,
			purchasedTradeUpdatee: true,
			purchasedTradeMessage: {
				status: null,
				text: null,
			},

			applicationsImplementedTrade: null,
			implementedTradeUpdatee: true,
			implementedTradeMessage: {
				status: null,
				text: null,
			},

			tabElement: 'tabElement1',
			tabElementChildren: 'tabElement1',
			tabElementChildre2: 'tabElement1',

			urlApi: urlApi,

			errorMessage: {
				status: null,
				messages: null,
				text: null,
			},
			message: {
				status: null,
				text: null,
			},

			headers3: [
				{ text: 'Id', value: 'id', width: '20px' },
				// {
				//   text: this.$t('headers.action'),
				//   value: 'action',
				//   align: 'center',
				//   sortable: false,
				//   width: '100px',
				// },
				{ text: this.$t('labels.catch'), value: 'catch_at', width: '10vw', sortable: true },
				{ text: this.$t('labels.brigade'), value: 'brigade_id', sortable: false },
				{ text: this.$t('headers.status'), value: 'status', sortable: false },
			],
			options3: {
				itemsPerPage: 5,
				page: 1,
				sortBy: ['catch_at'],
				sortDesc: [true],
			},
			totalTradeItems: 0,
			options4: {
				itemsPerPage: 5,
				page: 1,
			},

			referenceIntegrateUpdate: false,

			referenceOriginIntegrateList: null,
			referenceVeterinaryIntegrateList: null,
			certificateVeterinaryIntegrateList: null,

			permissionsIntegrateList: null,
			permissionsFilteredList: [],
			permissionsIntegrateUpdate: true,
			permissionsMessage: {
				status: null,
				text: null,
			},
			options2: {
				itemsPerPage: 5,
				page: 1,
			},

			erapMessage: {
				status: null,
				text: null,
			},
			erapIntegrateUpdate: false,
			erapIntegrateData: null,
			erapIntegrateList: null,
			options5: {
				itemsPerPage: 10,
				page: 1,
			},
			headers6: [
				{ text: 'Id', value: 'id', width: '50px' },
				{ text: this.$t('headers.operation_type'), value: 'TypeOperation' },
				{ text: this.$t('headers.custom_code'), value: 'CustomsCode' },
				{ text: this.$t('headers.product_date'), value: 'DateProduct' },
				{ text: this.$t('headers.country_origin'), value: 'CountryOrigin' },
				{ text: this.$t('headers.country_sender'), value: 'CountrySender' },
				{ text: this.$t('headers.country_destination'), value: 'CountryDestination' },
				{ text: this.$t('headers.code_state'), value: 'CodeState' },
				{
					text: this.$t('headers.document_number'),
					value: 'DocumentNumber',
				},
				{ text: this.$t('headers.customs_number'), value: 'CustomsNumber' },
				{ text: this.$t('headers.name_state'), value: 'NameState' },
				{ text: this.$t('headers.iin_bin_reciever'), value: 'IinBin' },
				{ text: this.$t('headers.fio_receiver'), value: 'FioReceiver', width: '600px' },
				{ text: this.$t('headers.item_code'), value: 'ItemCode' },
				{ text: this.$t('headers.item_name'), value: 'ItemName', width: '600px' },
				{ text: this.$t('headers.item_weight'), value: 'ItemWeight' },
				{ text: this.$t('headers.item_price'), value: 'ItemPrice' },
			],
			options6: {
				itemsPerPage: 5,
				page: 1,
			},
		}
	},
	computed: {
		...mapGetters(['_getRegionList', '_getFishes', '_getBrigades']),
		getBrigadeName() {
			return (id) => {
				return this._getBrigades.find((b) => b.id == id)?.title || '-'
			}
		},
		getHeaders3() {
			if (!this.applicationsTrade || !this._getFishes) {
				return this.headers3
			}

			return [
				...this.headers3,
				...this._getFishes
					.filter((fish) => {
						return this.applicationsTrade.some((item) => {
							return (
								item.fishs &&
								item.fishs.some((f) => {
									return f.fish_id === fish.id
								})
							)
						})
					})
					.map((fish) => {
						return { text: fish.name, value: 'fish', fish_id: fish.id, width: '150px' }
					}),
			]
		},
		isSalesman() {
			return this.applicationsUser?.role?.name === 'salesman'
		},
		showTradeTabs() {
			return !this.isSalesman
		},
		showSalesmanTabs() {
			return this.isSalesman
		},
		profileTabs() {
			return [
				this.showTradeTabs && { value: 'tabElement1', label: this.$t('headers.quotas') },
				{ value: 'tabElement7', label: this.$t('titles.projectPower') },
				this.showTradeTabs && { value: 'tabElement2', label: this.$t('headers.permissions') },
				{ value: 'tabElement3', label: this.$t('headers.journals') },
				this.showTradeTabs && { value: 'tabElement4', label: this.$t('headers.handbooks') },
				{ value: 'tabElement5', label: this.$t('sidebar.fine') },
				{ value: 'tabElement6', label: this.$t('headers.customs') },
			].filter(Boolean)
		},
		journalTabs() {
			return this.showTradeTabs ? [{ value: 'tabElement1', label: this.$t('sidebar.magazines_trade') }] : []
		},
	},
	watch: {
		tabElement(tab) {
			syncTabQuery(this.$router, this.$route, tab)
		},
	},
	methods: {
		...mapActions(['_fetchRegionList', '_fetchFishes', '_fetchBrigades', '_fetchPools', '_fetchPondList']),
		searchQuotaFilters() {
			// MainFilters updates route and emits search; AccontQuota watches $route.query
		},
		catchError(error) {
			if (error?.response?.status == 500) {
				this.errorMessage.status = 500
				this.errorMessage.text = this.$t('system_message.500')
			}
			if (error?.response?.status == 401) {
				this.errorMessage.status = 401
				this.errorMessage.text = error.response.data.error_message
				this.$router.push('/' + this.$i18n.locale + '/login')
			}
			if (error?.response?.status == 422) {
				this.errorMessage.status = 422
				this.errorMessage.text = error.response.data.error_message
			}
			if (error?.response?.status == 403) {
				this.errorMessage.status = 403
				this.errorMessage.text = error?.response?.data?.message
			}
		},
		findFish(fishs, id) {
			return fishs.find((fish) => fish.fish_id == id)?.value || '0'
		},
		regionList(regions) {
			const field = `title${this.$i18n.locale === 'kk' ? '_kz' : ''}`
			return regions
				.map((region) => {
					return region[field]
				})
				.join(', ')
		},
		pondList(ponds) {
			return ponds
				.map((pond) => {
					return pond['title']
				})
				.join(', ')
		},
		getRegionNames(regions) {
			// Get region names from handbook using region_id
			return regions
				.map((region) => {
					const handbookRegion = this._getRegionList.find((r) => r.id === region.region_id)
					return handbookRegion
						? handbookRegion[`title${this.$i18n.locale === 'kk' ? '_kz' : ''}`]
						: `Region ID: ${region.region_id}`
				})
				.join(', ')
		},
		getPoolNames(pools) {
			// Get pool names directly from the pools array
			return pools
				.map((pool) => {
					return pool.title
				})
				.join(', ')
		},
		fishList(id) {
			let name = ''
			this.applicationsFish.find((element) => {
				if (element.id == id) name = element.name
			})
			return name
		},
		totalFishVolume(value) {
			let total = 0
			value.find((element) => {
				total += Number(element.value)
			})
			return Math.abs(total)
		},
		totalVolume(value) {
			let total = 0
			value.find((element) => {
				total += Number(element.item.value)
			})
			return Math.abs(total)
		},
		totalVolumeQuota(value) {
			let total = 0
			value.find((element) => {
				if (element.type == 'quota') {
					total += Number(element.value)
				}
			})
			return Math.abs(total)
		},

		async apiGetUser() {
			try {
				const response = await apiSecond.get('v1/user')
				if (response.data) {
					this.applicationsUser = response.data
					if (this.applicationsUser.user_info) {
						this.applicationsUser.user_info = eval(
							'({obj:' + JSON.parse(this.applicationsUser.user_info) + '})',
						)
					}

					// Set default tab for salesman users
					if (this.isSalesman) {
						this.tabElement = 'tabElement3'
						this.tabElementChildren = 'tabElement3'
					}
				}
			} catch (error) {
				this.catchError(error)
			}
		},
		apiGetUserTrade() {
			if (!this.applicationsUser?.id) return

			this.tradeIntegrateUpdate = false
			this.apiGetUserTradeList()
		},
		paginationUserTradeList(options) {
			if (!this.applicationsUser?.id) return

			this.apiGetUserTradeList(options.page, options.itemsPerPage, options)
		},
		apiGetUserTradeList(page = 1, itemsPerPage = 10, options = {}) {
			if (!this.applicationsUser?.id) return

			let queries = `user_id=${this.applicationsUser.id}&page=${page}&per_page=${itemsPerPage}`

			if (options?.sortBy?.length) {
				const direction =
					!options.sortDesc?.length || !options.sortDesc[0] ? 'asc' : 'desc'
				queries += `&sort[${options.sortBy[0]}]=${direction}`
			} else {
				queries += `&sort[catch_at]=desc`
			}

			apiSecond
				.get(`v1/trade/list?${queries}`)
				.then((response) => {
					if (response.data) {
						this.applicationsTrade = response.data.data
						this.totalTradeItems = response.data.total
					}
				})
				.catch((error) => {
					this.catchError(error)
				})
		},
		apiGetUserGrownTrade() {
			this.grownTradeUpdatee = false
			this.applicationsGrownTrade = []
		},
		apiGetUserPurchasedTrade() {
			this.purchasedTradeUpdatee = false
			this.applicationsPurchasedTrade = []
		},
		apiGetUserImplementedTrade() {
			this.implementedTradeUpdatee = false
			this.applicationsImplementedTrade = []
		},
		apiGetPondList() {
			this.applicationsPond = []
		},
		apiGetRegionList() {
			this.applicationsRegion = []
		},
		apiGetPondFish() {
			this.applicationsFish = []
		},
		astanaIntegration() {
			if (!this.applicationsUser?.id) return

			this.astanaIntegrateData = null
			this.astanaIntegrateList = null

			this.astanaIntegrateUpdate = true

			this.astanaMessage = {
				status: null,
				text: null,
			}

			apiSecond
				.get(`v1/user/${this.applicationsUser.id}/astana-one`)
				.then((response) => {
					if (response.status == 200) {
						this.astanaIntegrateData = response.data.data

						if (
							this.astanaIntegrateData
							// .response
							//     && this.astanaIntegrateData.response.responseData
							//     && this.astanaIntegrateData.response.responseData.data
							//     && this.astanaIntegrateData.response.responseData.data.items
						) {
							this.astanaIntegrateList = this.astanaIntegrateData
							// .response.responseData.data.items.item.slice().reverse();
						}
						this.astanaIntegrateUpdate = false
					}
				})
				.catch((error) => {
					if (error?.response?.status == 500) {
						this.astanaMessage.status = 500
						this.astanaMessage.text = this.$t('system_message.500')
					} else if (error?.response?.status == 401) {
						this.astanaMessage.status = 401
						this.astanaMessage.text = error.response.data.error_message
						this.$router.push('/' + this.$i18n.locale + '/login')
					} else if (error?.response?.status == 404) {
						this.astanaMessage.status = error?.response?.status
						this.astanaMessage.text = this.$t('system_message.500')
					} else {
						this.astanaMessage.status = error?.response?.status
						this.astanaMessage.text = error.response.data.error_message
					}
					this.astanaIntegrateUpdate = false
				})
		},

		async apiGetList() {
			await this.apiGetUser()

			// Only proceed with other API calls if user data is loaded
			if (!this.applicationsUser) {
				return
			}

			//this.apiGetUserPermission();
			// this.apiGetUserReference();

			this.apiGetUserTrade()
			this.apiGetUserGrownTrade()
			this.apiGetUserPurchasedTrade()
			this.apiGetUserImplementedTrade()

			//Integration
			this.erapIntegration()
			this.hanbooksIntegration()
			this.permissionsIntegration()
			this.astanaIntegration()
		},

		//Integration
		async erapIntegration() {
			if (!this.applicationsUser?.id) return

			this.erapIntegrateData = null
			this.erapIntegrateList = null

			this.erapIntegrateUpdate = true

			const response = await apiSecond.get(`v1/integration/user/${this.applicationsUser.id}/erap`)

			if (response?.data?.data?.response?.responseInfo?.status?.code == 200) {
				this.erapIntegrateData = response.data.data
				let erapIntegrateList = []
				if (Array.isArray(this.erapIntegrateData.response.responseData.data.items)) {
					erapIntegrateList = this.erapIntegrateData.response.responseData.data.items
						.slice()
						.reverse()
				} else if (this.erapIntegrateData.response.responseData.data.items.item) {
					erapIntegrateList = [this.erapIntegrateData.response.responseData.data.items.item]
				}
				this.erapIntegrateList = erapIntegrateList.map((item) => {
					return {
						...(item || {}),
						article: this.$i18n.locale === 'ru' ? item?.article?.nameRu : item?.article?.nameKk,
						decisionOrgan:
							this.$i18n.locale === 'ru'
								? item?.decisionOrgan?.nameRu
								: item?.decisionOrgan?.nameKk,
					}
				})
			}

			this.erapMessage = {
				status: null,
				text: null,
			}
			this.erapIntegrateData = null
		},
		ersopRequestIntegration() {
			this.ersopMessage = {
				status: null,
				text: null,
			}
			apiSecond
				.get('v1/integration/user/' + this.$store.state.userObject?.id + '/ersop')
				.then(() => {})
				.catch((error) => {
					if (error.response) {
						if (error?.response?.status == 500) {
							this.ersopMessage.status = 500
							this.ersopMessage.text = this.$t('system_message.500')
						} else if (error?.response?.status == 401) {
							this.ersopMessage.status = 401
							this.ersopMessage.text = error.response.data.error_message
							this.$router.push('/' + this.$i18n.locale + '/login')
						} else if (error?.response?.status == 404) {
							this.ersopMessage.status = error?.response?.status
							this.ersopMessage.text = this.$t('system_message.500')
						} else {
							this.ersopMessage.status = error?.response?.status
							this.ersopMessage.text = error.response.data.error_message
						}
					}
					this.ersopIntegrateUpdate = false
				})
			this.ersopIntegration()
		},
		ersopIntegration() {
			this.ersopIntegrateData = null
			this.ersopIntegrateList = null

			this.ersopIntegrateUpdate = true

			this.ersopMessage = {
				status: null,
				text: null,
			}

			//apiSecond.get('v1/integration/user/'+this.$store.state.userObject?.id+'/ersop')
			apiSecond
				.post('v1/integrations/shep/ersop-get', {
					user_id: this.$store.state.userObject?.id,
				})
				.then((response) => {
					if (response.status == 200) {
						this.ersopIntegrateData = response.data.data
						this.ersopIntegrateList = response.data.data

						/*if (this.ersopIntegrateData.response
              && this.ersopIntegrateData.response.responseData
              && this.ersopIntegrateData.response.responseData.data
              && this.ersopIntegrateData.response.responseData.data.items
          ) {
            this.ersopIntegrateList
                = this.ersopIntegrateData.response.responseData.data.items.item.slice().reverse();
          }*/
						this.ersopIntegrateUpdate = false
					}
				})
				.catch((error) => {
					if (error.response) {
						if (error?.response?.status == 500) {
							this.ersopMessage.status = 500
							this.ersopMessage.text = this.$t('system_message.500')
						} else if (error?.response?.status == 401) {
							this.ersopMessage.status = 401
							this.ersopMessage.text = error.response.data.error_message
							this.$router.push('/' + this.$i18n.locale + '/login')
						} else if (error?.response?.status == 404) {
							this.ersopMessage.status = error?.response?.status
							this.ersopMessage.text = this.$t('system_message.500')
						} else {
							this.ersopMessage.status = error?.response?.status
							this.ersopMessage.text = error.response.data.error_message
						}
					}
					this.ersopIntegrateUpdate = false
				})
		},
		async hanbooksIntegration() {
			if (!this.$store.state.userObject?.id) return

			this.referenceOriginIntegrateList = null
			this.permissionsIntegrateUpdate = true
			this.permissionsMessage = {
				status: null,
				text: null,
			}

			apiSecond
				.get(
					'v1/integration/user/' + this.$store.state.userObject?.id + '/reference-doc-with-volumes',
				)
				.then((response) => {
					if (response.status == 200) {
						if (response.data.data) {
							this.referenceOriginIntegrateList = response.data.data
						}

						this.permissionsIntegrateUpdate = false
					}
				})
				.catch((error) => {
					if (error.response) {
						if (error?.response?.status == 500) {
							this.permissionsMessage.status = 500
							this.permissionsMessage.text = this.$t('system_message.500')
						} else if (error?.response?.status == 401) {
							this.permissionsMessage.status = 401
							this.permissionsMessage.text = error.response.data.error_message
							this.$router.push('/' + this.$i18n.locale + '/login')
						} else if (error?.response?.status == 404) {
							this.permissionsMessage.status = error?.response?.status
							this.permissionsMessage.text = this.$t('system_message.500')
						} else {
							this.permissionsMessage.status = error?.response?.status
							this.permissionsMessage.text = error.response.data.error_message
						}
					}
					this.permissionsIntegrateUpdate = false
				})
		},
		loadDocumentUrl(url, name) {
			apiSecond
				.post(
					`v1/integration/user/${this.$route.params.userId}/download-document`,
					{
						file: url,
					},
					{
						responseType: 'blob',
					},
				)
				.then((response) => {
					if (response) {
						loadFile(response?.data, 'application/pdf', name)
					}
				})
		},
		async permissionsIntegration() {
			if (!this.$store.state.userObject?.id) return

			this.permissionsIntegrateData = null
			this.permissionsIntegrateList = []
			this.permissionsIntegrateUpdate = true

			this.permissionsMessage = {
				status: null,
				text: null,
			}

			apiSecond
				.get('v1/integration/user/' + this.$store.state.userObject?.id + '/permissions-doc')
				.then((response) => {
					if (response.status == 200) {
						this.permissionsIntegrateData = response.data.data

						if (
							this.permissionsIntegrateData.response &&
							this.permissionsIntegrateData.response.responseData &&
							this.permissionsIntegrateData.response.responseData.data &&
							this.permissionsIntegrateData.response.responseData.data.Licenses
						) {
							this.permissionsIntegrateList =
								this.permissionsIntegrateData.response.responseData.data.Licenses?.UniversalLicense.slice().reverse() ||
								[]
						}

						this.permissionsIntegrateUpdate = false
					}
				})
				.catch((error) => {
					if (error.response) {
						if (error?.response?.status == 500) {
							this.permissionsMessage.status = 500
							this.permissionsMessage.text = this.$t('system_message.500')
						} else if (error?.response?.status == 401) {
							this.permissionsMessage.status = 401
							this.permissionsMessage.text = error.response.data.error_message
							this.$router.push('/' + this.$i18n.locale + '/login')
						} else if (error?.response?.status == 404) {
							this.permissionsMessage.status = error?.response?.status
							this.permissionsMessage.text = this.$t('system_message.500')
						} else {
							this.permissionsMessage.status = error?.response?.status
							this.permissionsMessage.text = error.response.data.error_message
						}
					}
					this.permissionsIntegrateUpdate = false
				})
		},
		setTab() {
			const queryTab = tabFromQuery(this.$route.query)
			if (queryTab && this.profileTabs.some((item) => item.value === queryTab)) this.tabElement = queryTab

			// Set default tab for salesman users
			if (this.isSalesman) {
				this.tabElement = 'tabElement3'
				this.tabElementChildren = 'tabElement3'
			}
		},
		switchTab(tabName) {
			// Prevent salesman users from accessing restricted tabs
			// if (
			// 	this.isSalesman &&
			// 	['tabElement1', 'tabElement2', 'tabElement5', 'tabElement6'].includes(tabName)
			// ) {
			// 	return
			// }
			this.tabElement = tabName
		},
		switchChildTab(tabName) {
			// Prevent salesman users from accessing restricted child tabs
			// if (this.isSalesman && ['tabElement1', 'tabElement2'].includes(tabName)) {
			// 	return
			// }
			this.tabElementChildren = tabName
		},
	},
	async mounted() {
		await this._fetchRegionList()
		await this._fetchFishes()
		await this._fetchBrigades()
		await this._fetchPools()
		await this._fetchPondList()
		await this.apiGetList()
		this.apiGetPondList()
		this.apiGetRegionList()
		this.apiGetPondFish()
		this.setTab()
	},
	beforeCreate() {
		if (!localStorage.token) {
			this.$router.push('/ru/login')
		}
	},
}
</script>

<template>
	<div
		class="wrap__content"
		v-bind:class="{
			'wrap__content--preloader':
				!applicationsUser || !applicationsPond || !applicationsRegion || !applicationsFish,
		}"
	>
		<v-preloader
			v-if="!applicationsUser || !applicationsPond || !applicationsRegion || !applicationsFish"
			:message="errorMessage"
		></v-preloader>

		<div
			class="container"
			v-if="applicationsUser && applicationsPond && applicationsRegion && applicationsFish"
		>
			<div class="row">
				<div class="col-xl-2 col-lg-3">
					<v-sidebar :active="['MyProfile']"></v-sidebar>
				</div>
				<div class="col-xl-10 col-lg-9">
					<div class="content-wrapper">
						<div class="aq-page aq-profile">
							<SubjectProfileCard
								:user="applicationsUser"
								:regions="applicationsUser.regions && applicationsUser.regions.length ? getRegionNames(applicationsUser.regions) : ''"
								:pools="isSalesman ? null : applicationsUser.pools && applicationsUser.pools.length ? getPoolNames(applicationsUser.pools) : ''"
							/>
							<nav class="aq-profile__nav">
								<AqTabs
									:value="tabElement"
									:items="profileTabs"
									:label="$t('profile_ui.sections')"
									@input="switchTab"
								/>
							</nav>

									<div class="user-profile__tabs--content">
										<div v-if="tabElement == 'tabElement1'" class="user-profile__tab--item">
											<MainFilters
												:filter-keys="['regions', 'reservoirs', 'plots', 'fishing_year']"
												:user-id="applicationsUser.id"
												class="mb-4"
												:filter-options="{
													regions: { multiple: true },
													reservoirs: { multiple: true },
													plots: { multiple: true },
												}"
												@search="searchQuotaFilters"
											/>
											<AccontQuota :user-id="applicationsUser.id" />
										</div>

										<div class="user-profile__tab--item" v-if="tabElement == 'tabElement2'">
											<div class="table__block--content user-profile__block--content">
												<div class="user-profile__block--update">
													<button
														class="user-profile--update"
														@click="permissionsIntegration"
														:disabled="permissionsIntegrateUpdate"
													>
														<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16.625 1.583v4.75h-4.75" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.375 9.5A7.125 7.125 0 0114.25 4.196l2.375 2.137M2.375 17.417v-4.75h4.75" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.625 9.5A7.126 7.126 0 014.75 14.804l-2.375-2.137" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
														{{ $t('commands.update') }}
													</button>
												</div>

												<PermissionsFishingPlans
													:licenses="permissionsIntegrateList || []"
													@change="permissionsFilteredList = $event"
												/>

												<v-data-table
													:headers="[
														{ text: $t('placeholder.name'), value: 'ActivityType' },
														{ text: $t('headers.number'), value: 'GlobalUniqueNumber' },
														{ text: $t('headers.nikad'), value: 'Nikad' },
														{ text: $t('headers.status'), value: 'Status' },
														{ text: $t('headers.date_issue'), value: 'IssueDate', width: '100px' },
														{
															text: $t('headers.fishing_plans'),
															value: 'FishingPlans',
															sortable: false,
														},
														{
															text: $t('headers.result_pdf'),
															value: 'DocumentUrl',
															align: 'center',
															sortable: false,
															width: '150px',
														},
													]"
													:items="permissionsFilteredList"
													:loading="false"
													:options.sync="options2"
													:footer-props="{
														'items-per-page-options': [5, 10, 20, 30, 40, 50],
													}"
												>
													<template v-slot:item.FishingPlans="{ item }">
														<div v-for="(plan, index) in item.FishingPlans || []" :key="index">
															{{ plan.FishType }} — {{ plan.Count | formatNumber }} {{ $t('permission_plans.unit') }}
														</div>
													</template>
													<template v-slot:item.ActivityType="{ item }">
														<span v-if="$i18n.locale == 'ru'">
															{{ item.ActivityType['NameRu'] }}
														</span>
														<span v-if="$i18n.locale == 'kz'">
															{{ item.ActivityType['NameKz'] }}
														</span>
														<span v-if="$i18n.locale == 'en'">
															{{ item.ActivityType['NameEn'] }}
														</span>
													</template>
													<template v-slot:item.GlobalUniqueNumber="{ item }">
														{{ item.GlobalUniqueNumber }}
													</template>
													<template v-slot:item.IssueDate="{ item }">
														{{ item.IssueDate | formatDate }}
													</template>
													<template v-slot:item.Status="{ item }">
														<span v-if="$i18n.locale == 'ru'">
															{{ item.Status['NameRu'] }}
														</span>
														<span v-if="$i18n.locale == 'kz'">
															{{ item.Status['NameKz'] }}
														</span>
														<span v-if="$i18n.locale == 'en'">
															{{ item.Status['NameRu'] }}
														</span>
													</template>
													<template v-slot:item.DocumentUrl="{ item }">
														<button
															class="tb__table--btn tb__table--delete"
															target="_blank"
															v-tooltip.top-center="{
																content: $t('button.download'),
																class: ['tooltip__btn'],
															}"
															@click="loadDocumentUrl(item.DocumentUrl, item.GlobalUniqueNumber)"
														>
															<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M4.304 7.295v20.947c0 .967.79 1.758 1.758 1.758h17.984c.966 0 1.757-.791 1.757-1.758V1.758C25.803.79 25.013 0 24.046 0H11.599" fill="#E74C3C"/><path d="M4.304 7.295H9.84c.967 0 1.758-.791 1.758-1.758V0" fill="#C0392B"/><path d="M2.397 19.653h1.907V17.14l-2.079 2.589c.036-.046.095-.075.172-.075zM27.71 19.653h-1.907V17.14l2.079 2.589c-.036-.046-.095-.075-.172-.075z" fill="#262626"/><path d="M25.907 25.238a.456.456 0 01-.396.275H4.596a.456.456 0 01-.396-.275l-1.994-5.31c-.056-.151.03-.275.19-.275H27.71c.161 0 .246.124.19.275l-1.993 5.31z" fill="#C0392B"/><path d="M9.822 23.974c0-.147.043-.26.13-.34.087-.08.214-.12.38-.12.158 0 .28.04.364.12.084.08.127.194.127.34a.436.436 0 01-.13.337.51.51 0 01-.361.12.547.547 0 01-.374-.12.425.425 0 01-.136-.337zM13.952 21.984c0 .392-.115.694-.346.907-.23.213-.558.32-.983.32h-.265v1.16h-.946v-3.5h1.211c.443 0 .775.097.997.29.221.193.332.467.332.823zm-1.594.455h.172a.47.47 0 00.339-.12.435.435 0 00.126-.33c0-.236-.131-.354-.393-.354h-.244v.804zM17.482 22.547c0 .584-.16 1.035-.483 1.35-.321.317-.773.475-1.356.475H14.51V20.87h1.212c.562 0 .996.144 1.301.431.306.287.459.702.459 1.245zm-.982.034c0-.321-.063-.559-.19-.714-.127-.155-.32-.232-.578-.232h-.276v1.961h.21c.288 0 .499-.083.633-.25.134-.167.201-.422.201-.765zM19.04 24.372h-.93V20.87h2.068v.759h-1.137v.668h1.049v.76h-1.05v1.314zM21.386 10.835c0 .241-.263.44-.586.44H9.224c-.322 0-.586-.199-.586-.44 0-.242.264-.44.586-.44H20.8c.323 0 .586.198.586.44zM21.362 13.471c0 .242-.264.44-.586.44H9.2c-.323 0-.586-.198-.586-.44 0-.241.263-.44.586-.44h11.576c.322 0 .586.199.586.44zM21.386 16.114c0 .241-.263.44-.586.44H9.224c-.322 0-.586-.198-.586-.44s.264-.44.586-.44H20.8c.323 0 .586.198.586.44z" fill="#fff"/></svg>
														</button>
													</template>
													<v-alert slot="no-results" :value="true" color="error">
														{{ $t('messages.search_not_have_resultes') }}
													</v-alert>
												</v-data-table>

												<div
													class="form__block--line form__messages"
													:class="{
														'form__messages--error': permissionsMessage.status != 200,
														'form__messages--success': permissionsMessage.status == 200,
													}"
													v-if="permissionsMessage.status"
												>
													<label class="form__block--input">
														<span class="form__block--title">
															{{ permissionsMessage.text }}
														</span>
													</label>
												</div>
											</div>
										</div>

										<div class="user-profile__tab--item" v-if="tabElement == 'tabElement3'">
											<div class="table__block--content user-profile__block--content">
												<AqTabs
													v-if="journalTabs.length"
													:value="tabElementChildren"
													size="sm"
													class="aq-profile__subnav"
													:items="journalTabs"
													:label="$t('profile_ui.journal_sections')"
													@input="switchChildTab"
												/>

												<div v-if="tabElementChildren == 'tabElement1'">
													<div class="user-profile__block--update">
														<button
															class="user-profile--update"
															@click="apiGetUserTrade"
															:disabled="tradeIntegrateUpdate"
														>
															<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16.625 1.583v4.75h-4.75" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.375 9.5A7.125 7.125 0 0114.25 4.196l2.375 2.137M2.375 17.417v-4.75h4.75" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.625 9.5A7.126 7.126 0 014.75 14.804l-2.375-2.137" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
															{{ $t('commands.update') }}
														</button>
													</div>

													<v-data-table
														:headers="getHeaders3"
														:items="applicationsTrade"
														:loading="false"
														:options.sync="options3"
														show-expand
														:server-items-length="totalTradeItems"
														:footer-props="{
															'items-per-page-options': [5, 10, 20, 30, 40, 50],
														}"
														@update:options="paginationUserTradeList"
														v-if="applicationsTrade"
													>
														<template v-slot:item.catch_at="{ item }">
															<router-link :to="'/' + $i18n.locale + '/account/trade/' + item.id">
																{{
																	$t('labels.catch_at', [
																		new Date(item.catch_at).toLocaleDateString(),
																	])
																}}
															</router-link>
														</template>
														<template v-slot:item.brigade_id="{ item }">
															{{ getBrigadeName(item.brigade_id) }}
														</template>
														<template v-slot:item.status="{ item }">
															<a
																class="tb__table--status"
																:class="{
																	'tb__status--success': item.status == 'active',
																	'tb__status--error': item.status == 'deleted',
																}"
															>
																{{ $t('status.' + item.status) }}
															</a>
														</template>
														<template v-slot:item.fish="{ header, item }">
															{{ findFish(item.fishs, header.fish_id) }}
														</template>
													</v-data-table>
												</div>
												<div v-if="tabElementChildren == 'tabElement2'">
													<div class="user-profile__block--update">
														<button
															class="user-profile--update"
															@click="apiGetUserGrownTrade"
															:disabled="grownTradeUpdatee"
															v-if="showTradeTabs"
														>
															<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16.625 1.583v4.75h-4.75" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.375 9.5A7.125 7.125 0 0114.25 4.196l2.375 2.137M2.375 17.417v-4.75h4.75" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.625 9.5A7.126 7.126 0 014.75 14.804l-2.375-2.137" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
															{{ $t('commands.update') }}
														</button>
													</div>

													<v-data-table
														:headers="[
															{ text: 'Id', value: 'id', width: '50px' },
															{ text: $t('headers.name'), value: 'name', width: '15vw' },
															{ text: 'Номер справки о происхождении', value: 'reference' },
															{ text: 'Дата забоя', value: 'catch_at' },
															{ text: $t('headers.volume'), value: 'volume', width: '150px' },
														]"
														:items="applicationsGrownTrade"
														:loading="false"
														:options.sync="options3"
														show-expand
														:footer-props="{
															'items-per-page-options': [5, 10, 20, 30, 40, 50],
														}"
														v-if="applicationsGrownTrade"
													>
														<template v-slot:expanded-item="{ headers, item }">
															<td
																:colspan="headers.length"
																style="padding: 0; border-radius: 10px !important"
															>
																<div class="v-data-table">
																	<div class="v-data-table__wrapper">
																		<table width="100%">
																			<thead class="v-data-table-header">
																				<tr>
																					<th
																						style="width: 120px; min-width: 120px; max-width: 120px"
																					></th>
																					<th style="width: 100%; min-width: 20vw">Рыбы</th>
																					<th
																						style="width: 150px; min-width: 150px; max-width: 150px"
																					>
																						Объем
																					</th>
																				</tr>
																			</thead>
																			<tbody>
																				<tr v-for="fish in item.fishs" :key="fish.fish_id">
																					<td></td>
																					<td>{{ fishList(fish.fish_id) }}</td>
																					<td>{{ Math.abs(fish.value) }}</td>
																				</tr>
																			</tbody>
																		</table>
																	</div>
																</div>
															</td>
														</template>
														<template v-slot:item.name="{ item }">
															Улов от {{ item.catch_at | formatOnlyDate }}
														</template>
														<template v-slot:item.volume="{ item }">
															{{ totalFishVolume(item.fishs) }}
														</template>
														<template v-slot:item.catch_at="{ item }">
															{{ item.catch_at | formatDate }}
														</template>
														<v-alert slot="no-results" :value="true" color="error">
															Ваш поиск по запросу не дал результатов.
														</v-alert>
													</v-data-table>
													<div
														class="form__block--line form__messages"
														:class="{
															'form__messages--error': grownTradeMessage.status != 200,
															'form__messages--success': grownTradeMessage.status == 200,
														}"
														v-if="grownTradeMessage.status"
													>
														<label class="form__block--input">
															<span class="form__block--title">
																{{ grownTradeMessage.text }}
															</span>
														</label>
													</div>
												</div>
												<div v-if="tabElementChildren == 'tabElement3'">
													<div class="user-profile__block--update">
														<button
															class="user-profile--update"
															@click="apiGetUserPurchasedTrade"
															:disabled="purchasedTradeUpdatee"
														>
															<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16.625 1.583v4.75h-4.75" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.375 9.5A7.125 7.125 0 0114.25 4.196l2.375 2.137M2.375 17.417v-4.75h4.75" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.625 9.5A7.126 7.126 0 014.75 14.804l-2.375-2.137" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
															{{ $t('commands.update') }}
														</button>
													</div>

													<v-data-table
														:headers="[
															{ text: 'Id', value: 'id', width: '50px' },
															{ text: this.$t('headers.name'), value: 'name', width: '15vw' },
															{ text: 'Номер справки о происхождении', value: 'reference' },
															{ text: 'Дата закупки', value: 'catch_at' },
															{ text: this.$t('headers.volume'), value: 'volume', width: '150px' },
														]"
														:items="applicationsPurchasedTrade"
														:loading="false"
														:options.sync="options3"
														show-expand
														:footer-props="{
															'items-per-page-options': [5, 10, 20, 30, 40, 50],
														}"
														v-if="applicationsPurchasedTrade"
													>
														<template v-slot:expanded-item="{ headers, item }">
															<td
																:colspan="headers.length"
																style="padding: 0; border-radius: 10px !important"
															>
																<div class="v-data-table">
																	<div class="v-data-table__wrapper">
																		<table width="100%">
																			<thead class="v-data-table-header">
																				<tr>
																					<th
																						style="width: 120px; min-width: 120px; max-width: 120px"
																					></th>
																					<th style="width: 100%; min-width: 20vw">Рыбы</th>
																					<th
																						style="width: 150px; min-width: 150px; max-width: 150px"
																					>
																						Объем
																					</th>
																				</tr>
																			</thead>
																			<tbody>
																				<tr v-for="fish in item.fishs" :key="fish.fish_id">
																					<td></td>
																					<td>{{ fishList(fish.fish_id) }}</td>
																					<td>{{ Math.abs(fish.value) }}</td>
																				</tr>
																			</tbody>
																		</table>
																	</div>
																</div>
															</td>
														</template>
														<template v-slot:item.name="{ item }">
															Улов от {{ item.catch_at | formatOnlyDate }}
														</template>
														<template v-slot:item.volume="{ item }">
															{{ totalFishVolume(item.fishs) }}
														</template>
														<template v-slot:item.catch_at="{ item }">
															{{ item.catch_at | formatDate }}
														</template>
														<v-alert slot="no-results" :value="true" color="error">
															Ваш поиск по запросу не дал результатов.
														</v-alert>
													</v-data-table>
													<div
														class="form__block--line form__messages"
														:class="{
															'form__messages--error': purchasedTradeMessage.status != 200,
															'form__messages--success': purchasedTradeMessage.status == 200,
														}"
														v-if="purchasedTradeMessage.status"
													>
														<label class="form__block--input">
															<span class="form__block--title">
																{{ purchasedTradeMessage.text }}
															</span>
														</label>
													</div>
												</div>
												<div v-if="tabElementChildren == 'tabElement4'">
													<div class="user-profile__block--update">
														<button
															class="user-profile--update"
															@click="apiGetUserImplementedTrade"
															:disabled="implementedTradeUpdatee"
														>
															<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16.625 1.583v4.75h-4.75" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.375 9.5A7.125 7.125 0 0114.25 4.196l2.375 2.137M2.375 17.417v-4.75h4.75" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.625 9.5A7.126 7.126 0 014.75 14.804l-2.375-2.137" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
															{{ $t('commands.update') }}
														</button>
													</div>

													<v-data-table
														:headers="[
															{ text: 'Id', value: 'id', width: '50px' },
															{ text: $t('headers.name'), value: 'name', width: '15vw' },
															{ text: 'Номер справки о происхождении', value: 'reference' },
															{ text: 'Дата реализации', value: 'catch_at' },
															{ text: this.$t('headers.volume'), value: 'volume', width: '150px' },
														]"
														:items="applicationsImplementedTrade"
														:loading="false"
														:options.sync="options3"
														show-expand
														:footer-props="{
															'items-per-page-options': [5, 10, 20, 30, 40, 50],
														}"
														v-if="applicationsImplementedTrade"
													>
														<template v-slot:expanded-item="{ headers, item }">
															<td
																:colspan="headers.length"
																style="padding: 0; border-radius: 10px !important"
															>
																<div class="v-data-table">
																	<div class="v-data-table__wrapper">
																		<table width="100%">
																			<thead class="v-data-table-header">
																				<tr>
																					<th
																						style="width: 120px; min-width: 120px; max-width: 120px"
																					></th>
																					<th style="width: 100%; min-width: 20vw">Рыбы</th>
																					<th
																						style="width: 150px; min-width: 150px; max-width: 150px"
																					>
																						Объем
																					</th>
																				</tr>
																			</thead>
																			<tbody>
																				<tr v-for="fish in item.fishs" :key="fish.fish_id">
																					<td></td>
																					<td>{{ fishList(fish.fish_id) }}</td>
																					<td>{{ Math.abs(fish.value) }}</td>
																				</tr>
																			</tbody>
																		</table>
																	</div>
																</div>
															</td>
														</template>
														<template v-slot:item.name="{ item }">
															Улов от {{ item.catch_at | formatOnlyDate }}
														</template>
														<template v-slot:item.volume="{ item }">
															{{ totalFishVolume(item.fishs) }}
														</template>
														<template v-slot:item.catch_at="{ item }">
															{{ item.catch_at | formatDate }}
														</template>
														<v-alert slot="no-results" :value="true" color="error">
															Ваш поиск по запросу не дал результатов.
														</v-alert>
													</v-data-table>
													<div
														class="form__block--line form__messages"
														:class="{
															'form__messages--error': implementedTradeMessage.status != 200,
															'form__messages--success': implementedTradeMessage.status == 200,
														}"
														v-if="implementedTradeMessage.status"
													>
														<label class="form__block--input">
															<span class="form__block--title">
																{{ implementedTradeMessage.text }}
															</span>
														</label>
													</div>
												</div>
											</div>
										</div>

										<div class="user-profile__tab--item" v-if="tabElement == 'tabElement4'">
											<div class="table__block--content user-profile__block--content">
												<div>
													<div class="user-profile__block--update">
														<button
															class="user-profile--update"
															@click="hanbooksIntegration"
															:disabled="permissionsIntegrateUpdate"
														>
															<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16.625 1.583v4.75h-4.75" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.375 9.5A7.125 7.125 0 0114.25 4.196l2.375 2.137M2.375 17.417v-4.75h4.75" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.625 9.5A7.126 7.126 0 014.75 14.804l-2.375-2.137" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
															{{ $t('commands.update') }}
														</button>
													</div>

													<v-data-table
														v-if="referenceOriginIntegrateList"
														:headers="[
															{ text: $t('headers.nikad'), value: 'nikad' },
															{ text: $t('headers.status'), value: 'status' },
															{
																text: $t('headers.date_issue'),
																value: 'issue_date',
																width: '100px',
															},
															{ text: `${$t('headers.volume')}, кг`, value: 'total_catch_volume' },
															{
																text: `${$t('headers.available_volume')}, кг`,
																value: 'available_volume',
															},
															{
																text: $t('headers.result_pdf'),
																value: 'pdf_url',
																align: 'center',
																sortable: false,
																width: '150px',
															},
														]"
														:items="referenceOriginIntegrateList"
														:loading="false"
														:options.sync="options2"
														:footer-props="{
															'items-per-page-options': [5, 10, 20, 30, 40, 50],
														}"
													>
														<template v-slot:item.issue_date="{ item }">
															{{ item.issue_date | formatDate }}
														</template>
														<template v-slot:item.pdf_url="{ item }">
															<a
																class="tb__table--btn tb__table--delete"
																target="_blank"
																v-tooltip.top-center="{
																	content: $t('button.download'),
																	class: ['tooltip__btn'],
																}"
																@click="loadDocumentUrl(item.pdf_url, item.bin)"
															>
																<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M4.304 7.295v20.947c0 .967.79 1.758 1.758 1.758h17.984c.966 0 1.757-.791 1.757-1.758V1.758C25.803.79 25.013 0 24.046 0H11.599" fill="#E74C3C"/><path d="M4.304 7.295H9.84c.967 0 1.758-.791 1.758-1.758V0" fill="#C0392B"/><path d="M2.397 19.653h1.907V17.14l-2.079 2.589c.036-.046.095-.075.172-.075zM27.71 19.653h-1.907V17.14l2.079 2.589c-.036-.046-.095-.075-.172-.075z" fill="#262626"/><path d="M25.907 25.238a.456.456 0 01-.396.275H4.596a.456.456 0 01-.396-.275l-1.994-5.31c-.056-.151.03-.275.19-.275H27.71c.161 0 .246.124.19.275l-1.993 5.31z" fill="#C0392B"/><path d="M9.822 23.974c0-.147.043-.26.13-.34.087-.08.214-.12.38-.12.158 0 .28.04.364.12.084.08.127.194.127.34a.436.436 0 01-.13.337.51.51 0 01-.361.12.547.547 0 01-.374-.12.425.425 0 01-.136-.337zM13.952 21.984c0 .392-.115.694-.346.907-.23.213-.558.32-.983.32h-.265v1.16h-.946v-3.5h1.211c.443 0 .775.097.997.29.221.193.332.467.332.823zm-1.594.455h.172a.47.47 0 00.339-.12.435.435 0 00.126-.33c0-.236-.131-.354-.393-.354h-.244v.804zM17.482 22.547c0 .584-.16 1.035-.483 1.35-.321.317-.773.475-1.356.475H14.51V20.87h1.212c.562 0 .996.144 1.301.431.306.287.459.702.459 1.245zm-.982.034c0-.321-.063-.559-.19-.714-.127-.155-.32-.232-.578-.232h-.276v1.961h.21c.288 0 .499-.083.633-.25.134-.167.201-.422.201-.765zM19.04 24.372h-.93V20.87h2.068v.759h-1.137v.668h1.049v.76h-1.05v1.314zM21.386 10.835c0 .241-.263.44-.586.44H9.224c-.322 0-.586-.199-.586-.44 0-.242.264-.44.586-.44H20.8c.323 0 .586.198.586.44zM21.362 13.471c0 .242-.264.44-.586.44H9.2c-.323 0-.586-.198-.586-.44 0-.241.263-.44.586-.44h11.576c.322 0 .586.199.586.44zM21.386 16.114c0 .241-.263.44-.586.44H9.224c-.322 0-.586-.198-.586-.44s.264-.44.586-.44H20.8c.323 0 .586.198.586.44z" fill="#fff"/></svg>
															</a>
														</template>
														<v-alert slot="no-results" :value="true" color="error">
															{{ $t('messages.search_not_have_resultes') }}
														</v-alert>
													</v-data-table>
												</div>

												<div
													class="form__block--line form__messages"
													:class="{
														'form__messages--error': permissionsMessage.status != 200,
														'form__messages--success': permissionsMessage.status == 200,
													}"
													v-if="permissionsMessage.status"
												>
													<label class="form__block--input">
														<span class="form__block--title">
															{{ permissionsMessage.text }}
														</span>
													</label>
												</div>
											</div>
										</div>

										<div class="user-profile__tab--item" v-if="tabElement == 'tabElement5'">
											<div class="table__block--content user-profile__block--content">
												<div class="user-profile__block--update">
													<button class="user-profile--update" @click="erapIntegration">
														<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16.625 1.583v4.75h-4.75" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.375 9.5A7.125 7.125 0 0114.25 4.196l2.375 2.137M2.375 17.417v-4.75h4.75" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.625 9.5A7.126 7.126 0 014.75 14.804l-2.375-2.137" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
														{{ $t('commands.update') }}
													</button>
												</div>

												<v-data-table
													v-if="erapIntegrateList"
													:headers="[
														{ text: $t('headers.name'), value: 'organizationName', width: '25vw' },
														{ text: $t('headers.offense'), value: 'article' },
														{ text: $t('headers.fine_amount'), value: 'totalAmount' },
														{ text: $t('headers.amount_payment'), value: 'collectedAmount' },
														{
															text: $t('headers.detecter_offense'),
															value: 'decisionOrgan',
															width: '150px',
														},
														{ text: $t('headers.date'), value: 'decisionDate', width: '150px' },
													]"
													:items="erapIntegrateList"
													:loading="false"
													:options.sync="options5"
													:footer-props="{
														'items-per-page-options': [5, 10, 20, 30, 40, 50],
													}"
												>
													<!-- <template v-slot:item.article="{ item }">
														<strong>{{ item.qualification_code }}</strong> -
														{{ item.qualification }}
													</template> -->
													<template v-slot:item.decisionDate="{ item }">
														{{ item.decisionDate | formatDate }}
													</template>
													<v-alert slot="no-results" :value="true" color="error">
														{{ $t('messages.search_not_have_resultes') }}
													</v-alert>
												</v-data-table>

												<div
													class="form__block--line form__messages"
													:class="{
														'form__messages--error': erapMessage.status != 200,
														'form__messages--success': erapMessage.status == 200,
													}"
													v-if="erapMessage.status"
												>
													<label class="form__block--input">
														<span class="form__block--title">
															{{ erapMessage.text }}
														</span>
													</label>
												</div>
											</div>
										</div>

										<div class="user-profile__tab--item" v-if="tabElement == 'tabElement6'">
											<div class="table__block--content user-profile__block--content">
												<div class="user-profile__block--update">
													<button
														class="user-profile--update"
														@click="astanaIntegration"
														:disabled="astanaIntegrateUpdate"
													>
														<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M16.625 1.583v4.75h-4.75" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.375 9.5A7.125 7.125 0 0114.25 4.196l2.375 2.137M2.375 17.417v-4.75h4.75" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.625 9.5A7.126 7.126 0 014.75 14.804l-2.375-2.137" stroke="#6D90B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
														{{ $t('commands.update') }}
													</button>
												</div>

												<v-data-table
													:headers="headers6"
													:items="astanaIntegrateList"
													:loading="false"
													:options.sync="options6"
													:footer-props="{
														'items-per-page-options': [5, 10, 20, 30, 40, 50],
													}"
													v-if="astanaIntegrateList"
												>
													<template v-slot:item.id="{ item }">
														{{ item.id }}
													</template>
													<template v-slot:item.TypeOperation="{ item }">
														{{ item.TypeOperation }}
													</template>
													<template v-slot:item.CustomsCode="{ item }">
														{{ item.CustomsCode }}
													</template>
													<template v-slot:item.DateProduct="{ item }">
														{{ item.DateProduct }}
													</template>
													<template v-slot:item.CountryOrigin="{ item }">
														{{ item.CountryOrigin }}
													</template>
													<template v-slot:item.CountrySender="{ item }">
														{{ item.CountrySender }}
													</template>
													<template v-slot:item.CountryDestination="{ item }">
														{{ item.CountryDestination }}
													</template>
													<template v-slot:item.CodeState="{ item }">
														{{ item.CodeState }}
													</template>
													<template v-slot:item.DocumentNumber="{ item }">
														{{ item.DocumentNumber }}
													</template>
													<template v-slot:item.CustomsNumber="{ item }">
														{{ item.CustomsNumber }}
													</template>
													<template v-slot:item.NameState="{ item }">
														{{ item.NameState }}
													</template>

													<template v-slot:item.IinBin="{ item }">
														{{ item.IinBin }}
													</template>

													<template v-slot:item.FioReceiver="{ item }">
														{{ item.FioReceiver }}
													</template>

													<template v-slot:item.ItemCode="{ item }">
														{{ item.ItemCode }}
													</template>

													<template v-slot:item.ItemName="{ item }">
														{{ item.ItemName }}
													</template>

													<template v-slot:item.ItemWeight="{ item }">
														{{ item.ItemWeight }}
													</template>
													<template v-slot:item.ItemPrice="{ item }">
														{{ item.ItemPrice }}
													</template>

													<v-alert slot="no-results" :value="true" color="error">
														{{ $t('messages.search_not_have_resultes') }}
													</v-alert>
												</v-data-table>

												<div
													class="form__block--line form__messages"
													:class="{
														'form__messages--error': astanaMessage.status != 200,
														'form__messages--success': astanaMessage.status == 200,
													}"
													v-if="astanaMessage.status"
												>
													<label class="form__block--input">
														<span class="form__block--title">
															{{ astanaMessage.text }}
														</span>
													</label>
												</div>
											</div>
										</div>

										<div v-if="tabElement == 'tabElement7'" class="user-profile__tab--item">
											<ProjectPowerUser :user-id="applicationsUser.id" />
										</div>
									</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.disabled {
	pointer-events: none;
	opacity: 0.5;
}
</style>
